<template>
  <div>
    <div class="fullHeight is-flex is-flex-direction-column is-align-items-center is-justify-content-center">
      <b-tabs type="is-toggle-rounded customTabs" expanded>
        <b-tab-item label="Login" icon="account">
          <p class="title is-4">Login</p>
          <form @keyup.enter="login({ email, password })">
            <b-field label="Email" label-position="on-border">
              <b-input v-model="email" placeholder="Email" autocomplete="email" />
            </b-field>
            <b-field label="Password" label-position="on-border">
              <b-input v-model="password" placeholder="Password" type="password" password-reveal />
            </b-field>
            <b-button class="is-info" type="submit" @click="login({ email, password })" :disabled="!canLogin" icon-right="send">
              <strong>Login</strong>
            </b-button>
          </form>
        </b-tab-item>
        <b-tab-item label="Register" icon="account-multiple">
          <p class="title is-4">Register</p>
          <p class="subtitle is-6 mb-4">For your location</p>
          <form @keyup.enter="register({ email, password, practice_name, first, last, is_owner: true })">
            <b-field label="Email" label-position="on-border">
              <b-input v-model="email" placeholder="Email" />
            </b-field>
            <b-field label="Password" label-position="on-border">
              <b-input v-model="password" placeholder="Password" type="password" autocomplete="new-password" password-reveal />
            </b-field>
            <b-field label="Practice Name" label-position="on-border">
              <b-input v-model="practice_name" placeholder="Practice Name" autocomplete="organization" />
            </b-field>
            <b-field label="First Name" label-position="on-border">
              <b-input v-model="first" placeholder="First Name" />
            </b-field>
            <b-field label="Last Name" label-position="on-border">
              <b-input v-model="last" placeholder="Last Name" />
            </b-field>
            <b-button @click="register({ email, password, practice_name, first, last, is_owner: true })" :disabled="!canRegister" class="is-success" type="submit" icon-right="send">
              <strong>Register</strong>
            </b-button>
          </form>
        </b-tab-item>
      </b-tabs>

    </div>
  </div>
</template>


<script>
import { mapActions } from "vuex";

export default {
  name: "Login",
  computed: {
    canRegister() {
      if (this.email && this.password && this.practice_name && this.first && this.last) {
        return true
      } else return false
    },
    canLogin() {
      if (this.email && this.password) {
        return true
      } else return false
    },
  },
  data() {
    return {
      email: "",
      password: "",
      practice_name: "",
      first: '',
      last: '',
    };
  },
  methods: {
    ...mapActions({
      login: "auth/login",
      register: "auth/register",
      logout: "auth/logout",
    })
  }
};
</script>


<style lang="scss" scoped>
.fullHeight {
  height: 100vh;
}
.customTabs {
  width: 100%;
}
.b-tabs {
  border-radius: 12px!important;
}
</style>